export const quoteErrorKey = (error: any) =>
  error?.response?.data?.missing_prices ? "order.missingConfiguration" : "order.generationFailed";
